import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { NavTabsMapping } from '@/widgets/Layout';

import { useNavigation } from '@/config/navigation';

import './NavTabsStyles.scss';

export const NavTabs: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const navigation = useNavigation();

  const activeTab = navigation.find((headerTab: string) => headerTab === pathname);

  return (
    <Tabs
      animated={false}
      items={navigation.map((headerTab: string) => ({
        key: headerTab,
        label: NavTabsMapping[headerTab],
      }))}
      className={`header-nav-tabs${activeTab ? '' : ' header-nav-tabs--no-active'}`}
      onChange={(key): void => {
        navigate(key);
      }}
      activeKey={activeTab ?? pathname}
    />
  );
};
